import { UIDO_EMAIL_BRAND } from "../config/emailBrand";

export const CALENDLY_URL = UIDO_EMAIL_BRAND.contact.calendly;

export const openCalendly = () => {
  if (typeof window === "undefined") return;

  if (window.Calendly?.initPopupWidget) {
    window.Calendly.initPopupWidget({ url: CALENDLY_URL });
    return;
  }

  window.open(CALENDLY_URL, "_blank", "noopener,noreferrer");
};
